import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CFormGroup,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

/**
 * GRUPOS — aba da turma.
 *
 * Grupos de alunos DENTRO de uma turma: o professor recorta a turma em
 * equipes. Um aluno pode estar em vários grupos da mesma turma, mas nunca
 * duas vezes no mesmo grupo — a regra é do banco (unique group_id + user_id),
 * não daqui.
 *
 * O backend recusa aluno que não seja da turma e devolve o resultado
 * discriminado em `inserted` / `already_in_group` / `not_in_room` em vez de
 * falhar a requisição inteira. Por isso o aviso abaixo é montado a partir da
 * resposta, e não do que foi enviado.
 *
 * A LISTA DE CANDIDATOS SAI DE community/room_user/list, não de um cadastro
 * de alunos: só quem está matriculado na turma pode entrar num grupo dela, e
 * é essa a mesma fonte que o backend usa para validar.
 */
class CommunityContentGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      erro: null,
      groups: [],

      // Criação/edição do grupo
      modalGroup: false,
      groupId: null,
      groupName: "",
      saving: false,

      // Exclusão
      modalDelete: false,
      deleteGroup: null,

      // Gerenciamento de alunos
      modalUsers: false,
      currentGroup: null,
      groupUsers: [],
      roomStudents: [],
      selected: [],
      loadingUsers: false
    };
  }

  componentDidMount() {
    this.handleGroups();
  }

  get roomId() {
    return this.props.match.params.id;
  }

  get authHeaders() {
    return { headers: { Authorization: `Bearer ${this.props.user.token}` } };
  }

  handleGroups() {
    this.setState({ loading: true });

    axios
      .get(`${URL.api}community/room_group/list`, {
        params: { room_id: this.roomId },
        ...this.authHeaders
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ groups: resp.data.data, loading: false, erro: null });
        } else {
          this.setState({ loading: false, erro: resp.data.error });
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          erro: "Não foi possível carregar os grupos da turma."
        });
      });
  }

  // ----------------------------------------------------------------
  // Grupo
  // ----------------------------------------------------------------

  openGroupModal(group) {
    this.setState({
      modalGroup: true,
      groupId: group ? group.id : null,
      groupName: group ? group.name : ""
    });
  }

  saveGroup = () => {
    const name = this.state.groupName.trim();

    if (!name) {
      toastr.warning("Atenção", "Informe o nome do grupo.");
      return;
    }

    const { groupId } = this.state;
    const url = groupId
      ? `${URL.api}community/room_group/update/${groupId}`
      : `${URL.api}community/room_group/insert`;

    this.setState({ saving: true });

    axios
      .post(
        url,
        groupId ? { name } : { room_id: this.roomId, name },
        this.authHeaders
      )
      .then(resp => {
        this.setState({ saving: false });

        if (!resp.data.success) {
          toastr.error("Falha", resp.data.error);
          return;
        }

        toastr.success(
          "Sucesso",
          groupId ? "Grupo atualizado." : "Grupo criado."
        );
        this.setState({ modalGroup: false });
        this.handleGroups();
      })
      .catch(() => {
        this.setState({ saving: false });
        toastr.error("Falha", "Não foi possível salvar o grupo.");
      });
  };

  deleteGroup = () => {
    const group = this.state.deleteGroup;

    axios
      .post(
        `${URL.api}community/room_group/delete/${group.id}`,
        {},
        this.authHeaders
      )
      .then(resp => {
        if (!resp.data.success) {
          toastr.error("Falha", resp.data.error);
          return;
        }

        toastr.success("Sucesso", "Grupo excluído.");
        this.setState({ modalDelete: false, deleteGroup: null });
        this.handleGroups();
      })
      .catch(() => {
        toastr.error("Falha", "Não foi possível excluir o grupo.");
      });
  };

  // ----------------------------------------------------------------
  // Alunos do grupo
  // ----------------------------------------------------------------

  openUsersModal(group) {
    this.setState({
      modalUsers: true,
      currentGroup: group,
      groupUsers: [],
      roomStudents: [],
      selected: [],
      loadingUsers: true
    });

    // Os alunos do grupo e a turma inteira: o segundo é a lista de candidatos,
    // e sem os dois não há como saber quem ainda pode entrar.
    Promise.all([
      axios.get(`${URL.api}community/room_group/listUsers`, {
        params: { group_id: group.id },
        ...this.authHeaders
      }),
      axios.post(
        `${URL.api}community/room_user/list`,
        { room: this.roomId },
        this.authHeaders
      )
    ])
      .then(([groupResp, roomResp]) => {
        const groupUsers = groupResp.data.success ? groupResp.data.data : [];

        // `administrator` marca professor da turma; grupo é de aluno.
        const roomStudents = roomResp.data.success
          ? roomResp.data.data.filter(item => !item.administrator)
          : [];

        this.setState({ groupUsers, roomStudents, loadingUsers: false });
      })
      .catch(() => {
        this.setState({ loadingUsers: false });
        toastr.error("Falha", "Não foi possível carregar os alunos do grupo.");
      });
  }

  refreshGroupUsers() {
    return (
      axios
        .get(`${URL.api}community/room_group/listUsers`, {
          params: { group_id: this.state.currentGroup.id },
          ...this.authHeaders
        })
        .then(resp => {
          this.setState({
            groupUsers: resp.data.success ? resp.data.data : []
          });
          // A contagem da listagem de trás fica velha depois de mexer nos alunos.
          this.handleGroups();
        })
        // Sem este catch a rejeição fica sem tratamento: quem chama não usa o
        // retorno, e uma promise rejeitada solta acorda o overlay de erro do
        // dev server em cima da tela inteira.
        .catch(() => {
          toastr.error(
            "Falha",
            "Não foi possível atualizar os alunos do grupo."
          );
        })
    );
  }

  toggleSelected(userId) {
    this.setState(state => ({
      selected: state.selected.includes(userId)
        ? state.selected.filter(id => id !== userId)
        : [...state.selected, userId]
    }));
  }

  addUsers = () => {
    const { selected, currentGroup } = this.state;

    if (selected.length === 0) {
      toastr.warning("Atenção", "Selecione ao menos um aluno.");
      return;
    }

    axios
      .post(
        `${URL.api}community/room_group/insertUsers`,
        { group_id: currentGroup.id, users: selected },
        this.authHeaders
      )
      .then(resp => {
        if (!resp.data.success) {
          toastr.error("Falha", resp.data.error);
          return;
        }

        const {
          inserted,
          already_in_group: alreadyInGroup,
          not_in_room: notInRoom
        } = resp.data.data;

        if (inserted.length > 0) {
          toastr.success(
            "Sucesso",
            `${inserted.length} aluno(s) adicionado(s) ao grupo.`
          );
        }

        // O backend aceita em parte: o que ele recusou precisa aparecer, senão
        // o professor acha que entrou todo mundo.
        if (alreadyInGroup.length > 0) {
          toastr.info(
            "Atenção",
            `${alreadyInGroup.length} aluno(s) já estavam no grupo.`
          );
        }

        if (notInRoom.length > 0) {
          toastr.warning(
            "Atenção",
            `${notInRoom.length} aluno(s) não pertencem a esta turma.`
          );
        }

        this.setState({ selected: [] });
        this.refreshGroupUsers();
      })
      .catch(() => {
        toastr.error("Falha", "Não foi possível adicionar os alunos.");
      });
  };

  removeUser(userId) {
    axios
      .post(
        `${URL.api}community/room_group/deleteUsers`,
        { group_id: this.state.currentGroup.id, users: [userId] },
        this.authHeaders
      )
      .then(resp => {
        if (!resp.data.success) {
          toastr.error("Falha", resp.data.error);
          return;
        }

        toastr.success("Sucesso", "Aluno removido do grupo.");
        this.refreshGroupUsers();
      })
      .catch(() => {
        toastr.error("Falha", "Não foi possível remover o aluno.");
      });
  }

  // ----------------------------------------------------------------

  renderGroups() {
    if (this.state.groups.length === 0) {
      return (
        <div className="text-muted">
          Esta turma ainda não possui grupos.
          {this.props.hasPrivilege &&
            ' Use "Novo grupo" para criar o primeiro.'}
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Grupo</th>
              <th className="text-center">Alunos</th>
              {this.props.hasPrivilege && <th className="text-right">Ações</th>}
            </tr>
          </thead>
          <tbody>
            {this.state.groups.map(group => (
              <tr key={group.id}>
                <td className="align-middle">{group.name}</td>
                <td className="align-middle text-center">{group.num_users}</td>
                {this.props.hasPrivilege && (
                  <td className="align-middle text-right">
                    <CButton
                      size="sm"
                      color="primary"
                      variant="outline"
                      className="mr-2"
                      onClick={() => this.openUsersModal(group)}
                    >
                      <i className="fa fa-users mr-1"></i> Alunos
                    </CButton>
                    <CButton
                      size="sm"
                      color="dark"
                      variant="outline"
                      className="mr-2"
                      onClick={() => this.openGroupModal(group)}
                    >
                      <i className="fa fa-pencil"></i>
                    </CButton>
                    <CButton
                      size="sm"
                      color="danger"
                      variant="outline"
                      onClick={() =>
                        this.setState({ modalDelete: true, deleteGroup: group })
                      }
                    >
                      <i className="fa fa-trash"></i>
                    </CButton>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderUsersModal() {
    const { currentGroup, groupUsers, roomStudents, selected } = this.state;

    if (!currentGroup) {
      return null;
    }

    const inGroup = groupUsers.map(item => item.user_id);
    const candidates = roomStudents.filter(
      item => !inGroup.includes(item.user_id)
    );

    return (
      <CModal
        show={this.state.modalUsers}
        size="lg"
        onClose={() => this.setState({ modalUsers: false })}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Alunos do grupo {currentGroup.name}</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ padding: "12px" }}>
          {this.state.loadingUsers ? (
            <Loading />
          ) : (
            <div className="row">
              <div className="col-md-6">
                <h6>No grupo ({groupUsers.length})</h6>
                {groupUsers.length === 0 ? (
                  <div className="text-muted small">
                    Nenhum aluno neste grupo.
                  </div>
                ) : (
                  <ul className="list-group">
                    {groupUsers.map(item => (
                      <li
                        key={item.id}
                        className="list-group-item d-flex justify-content-between align-items-center py-2"
                      >
                        <span>{item.user_name}</span>
                        <CButton
                          size="sm"
                          color="danger"
                          variant="outline"
                          onClick={() => this.removeUser(item.user_id)}
                        >
                          <i className="fa fa-trash"></i>
                        </CButton>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="col-md-6">
                <h6>Disponíveis na turma ({candidates.length})</h6>
                {candidates.length === 0 ? (
                  <div className="text-muted small">
                    Todos os alunos da turma já estão neste grupo.
                  </div>
                ) : (
                  <>
                    <ul
                      className="list-group mb-2"
                      style={{ maxHeight: "320px", overflowY: "auto" }}
                    >
                      {candidates.map(item => (
                        <li
                          key={item.user_id}
                          className="list-group-item py-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleSelected(item.user_id)}
                        >
                          {/* Sem onChange de propósito: o clique aqui
                              borbulha para o onClick do <li>, que é o único
                              dono do toggle. Com um handler nos dois, o
                              clique no próprio checkbox alternava duas vezes
                              e nada acontecia. `readOnly` deixa isso
                              explícito e evita o aviso de campo controlado
                              sem onChange. */}
                          <input
                            type="checkbox"
                            className="mr-2"
                            checked={selected.includes(item.user_id)}
                            readOnly
                          />
                          {item.user_name}
                        </li>
                      ))}
                    </ul>
                    <CButton
                      color="primary"
                      disabled={selected.length === 0}
                      onClick={this.addUsers}
                    >
                      Adicionar {selected.length > 0 && `(${selected.length})`}
                    </CButton>
                  </>
                )}
              </div>
            </div>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => this.setState({ modalUsers: false })}
          >
            Fechar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }

  render() {
    return (
      <CCard>
        <CCardHeader className="d-flex justify-content-between align-items-center">
          <span>Grupos da turma</span>
          {this.props.hasPrivilege && (
            <CButton
              size="sm"
              color="primary"
              onClick={() => this.openGroupModal(null)}
            >
              <i className="fa fa-plus mr-1"></i> Novo grupo
            </CButton>
          )}
        </CCardHeader>
        <CCardBody>
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : this.state.erro ? (
            <div className="text-muted">{this.state.erro}</div>
          ) : (
            this.renderGroups()
          )}
        </CCardBody>

        <CModal
          show={this.state.modalGroup}
          onClose={() => this.setState({ modalGroup: false })}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>
              {this.state.groupId ? "Editar grupo" : "Novo grupo"}
            </CModalTitle>
          </CModalHeader>
          <CModalBody style={{ padding: "12px" }}>
            <CFormGroup>
              <CLabel htmlFor="group-name">Nome do grupo</CLabel>
              <CInput
                id="group-name"
                type="text"
                value={this.state.groupName}
                placeholder="Ex.: Grupo A"
                onChange={e => this.setState({ groupName: e.target.value })}
              />
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              disabled={this.state.saving}
              onClick={this.saveGroup}
            >
              {this.state.saving ? "Salvando..." : "Salvar"}
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => this.setState({ modalGroup: false })}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          show={this.state.modalDelete}
          onClose={() => this.setState({ modalDelete: false })}
          closeOnBackdrop={false}
        >
          {/* Sem bg-danger: o .modal-content tem `padding: 0 15px` global
              (components/Modal/modal.css), então uma faixa de fundo colorida
              no header não alcança as bordas nem os cantos arredondados --
              fica uma tarja encolhida dentro do modal. O peso de ação
              destrutiva já está no botão "Apagar". */}
          <CModalHeader closeButton>
            <CModalTitle>Excluir grupo</CModalTitle>
          </CModalHeader>
          <CModalBody style={{ padding: "12px" }}>
            Deseja excluir o grupo{" "}
            <strong>
              {this.state.deleteGroup && this.state.deleteGroup.name}
            </strong>
            ? Os alunos serão desvinculados do grupo, mas continuam na turma.
          </CModalBody>
          <CModalFooter>
            <CButton color="danger" onClick={this.deleteGroup}>
              Apagar
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => this.setState({ modalDelete: false })}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>

        {this.renderUsersModal()}
      </CCard>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(CommunityContentGroups);
